import { render } from "./attrs.vue?vue&type=template&id=cc42c36a&scoped=true"
import script from "./attrs.vue?vue&type=script&lang=ts"
export * from "./attrs.vue?vue&type=script&lang=ts"

import "./attrs.vue?vue&type=style&index=0&id=cc42c36a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-cc42c36a"

export default script